exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".paddingbot20 {\n  padding-bottom: 20px;\n}\n\n.container-login {\n  max-width: 500px;\n}\n\n.text-login {\n  color: #f8f8f8;\n}\n\n.header-login {\n  text-align: center;\n  margin-bottom: 30px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/login/login.component.css
// module id = ../../../../../src/app/modules/login/login.component.css
// module chunks = main